export default "__VITE_ASSET__C75Mjlyx__"